import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-know-your-test',
  templateUrl: './know-your-test.component.html',
  styleUrls: ['./know-your-test.component.css']
})
export class KnowYourTestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
